import { CellType } from "./universal-dataset-table-editor/EditBasicCellDialog";
import { IUniversalDatasetTableRow } from "./UniversalDatasetTableRow";

const getUniversalTableDatasetValues = (rows: IUniversalDatasetTableRow[]) => {
  const datasetValues: string[] = [];
  rows.forEach(row => {
    row.columns.forEach(column => {
      if (column.cell.type === CellType.DATASET) {
        datasetValues.push(column.cell.value as string);
      }
    });
  });
  return datasetValues.filter(Boolean);
};

const findUniversalTableRowIdentifiers = (row: IUniversalDatasetTableRow) => {
  return row.columns
    .filter(column => column.cell.type === CellType.DATASET)
    .map(column => column.cell.value as string);
};

export { getUniversalTableDatasetValues, findUniversalTableRowIdentifiers };
